import { buildTheme } from '@/theme/buildTheme';

export interface BrandColors {
  primary_color?: string;
  accent_color?: string;
  success_color?: string;
  /** Canvas base. Internal: comes from the system-layer brand config (default RoofVox Brand Navy); no tenant UI edits it. */
  base_color?: string;
}

/** The brand last applied, so a partial call (e.g. the setup wizard previewing just a primary colour) changes only
 *  what it names and leaves the accent / success / base as they were. */
let applied: BrandColors = {};

/**
 * Apply the brand to the document. The colours are turned into the full token set by buildTheme()
 * (src/theme/buildTheme.ts); index.css resolves the `-light` / `-dark` variants per mode, so calling this
 * restyles the whole app immediately with no per-component work. Missing or invalid colours fall back to
 * the platform defaults.
 */
export function applyTheme(colors: BrandColors): void {
  const root = document.documentElement;
  applied = {
    ...applied,
    ...Object.fromEntries(Object.entries(colors).filter(([, v]) => v !== undefined)),
  };
  const theme = buildTheme({
    primary: applied.primary_color,
    accent: applied.accent_color,
    success: applied.success_color,
    base: applied.base_color,
  });

  Object.entries(theme.shared).forEach(([name, value]) => root.style.setProperty(name, value));
  Object.entries(theme.light).forEach(([name, value]) => root.style.setProperty(`${name}-light`, value));
  Object.entries(theme.dark).forEach(([name, value]) => root.style.setProperty(`${name}-dark`, value));
}
